(function () {
  const DRAG_THRESHOLD = 6;

  function initTrack(track) {
    if (!track || track.dataset.hcssReady === 'true') return;
    track.dataset.hcssReady = 'true';

    let isPointerDown = false;
    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;
    let moved = false;
    let activePointerId = null;

    const onPointerDown = (event) => {
      if (event.pointerType === 'touch') return;
      if (event.button !== 0) return;

      isPointerDown = true;
      isDragging = false;
      moved = false;
      startX = event.clientX;
      scrollStart = track.scrollLeft;
      activePointerId = event.pointerId;
    };

    const onPointerMove = (event) => {
      if (!isPointerDown || event.pointerId !== activePointerId) return;

      const delta = event.clientX - startX;

      if (!isDragging) {
        if (Math.abs(delta) <= DRAG_THRESHOLD) return;

        isDragging = true;
        moved = true;
        track.classList.add('is-dragging');

        try {
          track.setPointerCapture(event.pointerId);
        } catch (e) {
          /* ignore */
        }
      }

      track.scrollLeft = scrollStart - delta;
    };

    const endDrag = (event) => {
      if (!isPointerDown || event.pointerId !== activePointerId) return;

      isPointerDown = false;
      isDragging = false;
      activePointerId = null;
      track.classList.remove('is-dragging');

      try {
        track.releasePointerCapture(event.pointerId);
      } catch (e) {
        /* ignore */
      }

      if (event.type === 'pointercancel') moved = false;
    };

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      (event) => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function initAll() {
    document
      .querySelectorAll('[data-home-collections-simple-slider-track]')
      .forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
